/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DurationUnit } from './';
import {
    DurationUnitFromJSON,
    DurationUnitFromJSONTyped,
    DurationUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface DurationChoiceResource
 */
export interface DurationChoiceResource {
    /**
     * 
     * @type {number}
     * @memberof DurationChoiceResource
     */
    amount: number;
    /**
     * 
     * @type {DurationUnit}
     * @memberof DurationChoiceResource
     */
    unit: DurationUnit;
    /**
     * Is this a fixed duration project
     * @type {boolean}
     * @memberof DurationChoiceResource
     */
    durationFixed: boolean;
}

/**
 * Check if a given object implements the DurationChoiceResource interface.
 */
export function instanceOfDurationChoiceResource(value: object): value is DurationChoiceResource {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('durationFixed' in value) || value['durationFixed'] === undefined) return false;
    return true;
}

export function DurationChoiceResourceFromJSON(json: any): DurationChoiceResource {
    return DurationChoiceResourceFromJSONTyped(json, false);
}

export function DurationChoiceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationChoiceResource {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'unit': DurationUnitFromJSON(json['unit']),
        'durationFixed': json['durationFixed'],
    };
}

export function DurationChoiceResourceToJSON(value?: DurationChoiceResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'unit': DurationUnitToJSON(value['unit']),
        'durationFixed': value['durationFixed'],
    };
}

